import { Typography } from "antd";

const TermsOfService = () => {
  return (
    <>
      <div className="features" id="about">
        <div className="header-text">Our Terms of Service</div>

        <div>
          <Typography.Text className="privacy-text">
            <strong>TERMS OF SERVICE – HAVETO PAY</strong>
            <br />
            <br />
            <strong>Effective Date:</strong> 17th-Feb-2026
            <br />
            <strong>Operated by:</strong> Haveto.com
            <br />
            <strong>Product:</strong> Haveto Pay
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>1. INTRODUCTION</strong>
            <br />
            These Terms of Service (“Terms”) govern your access to and use of Haveto Pay (“Platform”), operated by Haveto.com (“Company”, “we”, “us”, “our”).
            <br /><br />
            Haveto Pay is a centralized platform that facilitates:
            <br />• Fiat payment processing
            <br />• Token reservation services
            <br />• Internal wallet ledger management
            <br />• Settlement processing to the Haveto blockchain network
            <br /><br />
            By using Haveto Pay, you agree to be legally bound by these Terms.
            If you do not agree, you must not use the Platform.
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>2. NATURE OF SERVICE</strong>
            <br />
            Haveto Pay:
            <br />• Is a reservation and settlement platform
            <br />• Is a fiat transaction processing facilitator
            <br />• Maintains an internal custodial wallet ledger
            <br /><br />
            Haveto Pay:
            <br />❌ Is not a bank
            <br />❌ Is not a deposit-taking institution
            <br />❌ Is not a cryptocurrency exchange
            <br />❌ Does not provide investment advice
            <br />❌ Does not guarantee profits
            <br /><br />
            All services are provided on a best-effort basis.
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>3. ELIGIBILITY</strong>
            <br />
            To use Haveto Pay, you must:
            <br />• Be at least 18 years old
            <br />• Be legally capable of entering into contracts
            <br />• Complete KYC verification
            <br />• Not be restricted under applicable sanctions laws
            <br /><br />
            We reserve the right to refuse service at our discretion.
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>4. ACCOUNT REGISTRATION</strong>
            <br />
            You agree to:
            <br />• Provide accurate information
            <br />• Maintain confidentiality of login credentials
            <br />• Immediately notify us of unauthorized use
            <br /><br />
            You are fully responsible for all activities under your account.
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>5. KYC & AML COMPLIANCE</strong>
            <br />
            Haveto Pay complies with applicable Indian laws including:
            <br />• Prevention of Money Laundering Act (PMLA)
            <br />• Applicable AML regulations
            <br /><br />
            We may:
            <br />• Request identity verification documents
            <br />• Conduct enhanced due diligence
            <br />• Freeze accounts pending review
            <br />• Report suspicious transactions to authorities
            <br /><br />
            Failure to provide required information may result in suspension.
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>6. TOKEN RESERVATION MODEL</strong>
            <br />
            Haveto Pay allows users to:
            <br />• Reserve digital tokens using fiat currency
            <br />• Lock price exposure at time of reservation
            <br />• View internal ledger allocation
            <br /><br />
            <strong>Important:</strong>
            <br />• Token balances displayed represent internal ledger entries
            <br />• On-chain settlement may be subject to processing time
            <br />• Liquidity availability is not guaranteed
            <br />• The Company may manage liquidity manually or algorithmically
            <br />• Reservation does not constitute an investment contract
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>7. PAYMENT PROCESSING</strong>
            <br />
            Haveto Pay facilitates payments via:
            <br />• UPI
            <br />• Bank transfer
            <br />• Other approved payment methods
            <br /><br />
            The Company:
            <br />• Does not control third-party banking systems
            <br />• Is not liable for banking network failures
            <br />• May delay settlement due to compliance review
            <br />• May impose transaction limits
            <br />• Transactions are considered final only upon confirmation
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>8. WALLET & CUSTODY</strong>
            <br />
            Haveto Pay wallet:
            <br />• Is an internal custodial ledger system
            <br />• Does not constitute a bank account
            <br />• Is not insured by any government authority
            <br />• Does not earn interest unless explicitly stated
            <br /><br />
            Users acknowledge that:
            <br />• Funds may be pooled for operational liquidity
            <br />• Settlement timing may vary
            <br />• Withdrawal limits may apply
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>9. WITHDRAWALS & REDEMPTIONS</strong>
            <br />
            Withdrawals may be subject to:
            <br />• Daily transaction limits
            <br />• Liquidity availability
            <br />• Compliance review
            <br />• Fraud checks
            <br /><br />
            The Company reserves the right to delay, restrict, or refuse withdrawals if:
            <br />• Fraud is suspected
            <br />• Regulatory obligations require review
            <br />• System integrity is threatened
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>10. FEES & PRICING</strong>
            <br />
            Haveto Pay may charge:
            <br />• Platform fees
            <br />• Payment processing fees
            <br />• Withdrawal fees
            <br />• Spread-based pricing adjustments
            <br /><br />
            All applicable fees will be disclosed within the platform.
            We may update fee structures with reasonable notice.
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>11. RISK DISCLOSURE</strong>
            <br />
            By using Haveto Pay, you acknowledge:
            <br />• Digital asset prices are volatile
            <br />• Market liquidity may fluctuate
            <br />• Regulatory changes may impact operations
            <br />• Technical failures may occur
            <br />• You may lose value
            <br /><br />
            The Company does not guarantee price stability or liquidity.
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>12. TAX RESPONSIBILITY</strong>
            <br />
            Users are solely responsible for:
            <br />• Reporting income
            <br />• Paying applicable taxes
            <br />• Maintaining transaction records
            <br /><br />
            Haveto Pay does not provide tax advice.
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>13. PROHIBITED USE</strong>
            <br />
            You may not use Haveto Pay for:
            <br />• Money laundering
            <br />• Terrorist financing
            <br />• Fraudulent activity
            <br />• Market manipulation
            <br />• Exploiting system vulnerabilities
            <br /><br />
            Violation may result in:
            <br />• Immediate account suspension
            <br />• Asset freeze
            <br />• Legal action
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>14. LIMITATION OF LIABILITY</strong>
            <br />
            To the maximum extent permitted by law:
            <br />• Haveto Pay shall not be liable for loss of profits
            <br />• Indirect damages
            <br />• Market losses
            <br />• Delayed settlements
            <br />• Third-party payment failures
            <br /><br />
            Total liability shall not exceed fees paid by you in the last 30 days.
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>15. INDEMNIFICATION</strong>
            <br />
            You agree to indemnify the Company against:
            <br />• Claims arising from your misuse
            <br />• Regulatory penalties caused by your conduct
            <br />• Fraud conducted through your account
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>16. TERMINATION</strong>
            <br />
            We may suspend or terminate your account if:
            <br />• Terms are violated
            <br />• Compliance risks arise
            <br />• Required by law
            <br /><br />
            You may request account closure subject to pending settlements.
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>17. FORCE MAJEURE</strong>
            <br />
            We are not liable for failure due to:
            <br />• Government action
            <br />• Regulatory changes
            <br />• Banking disruptions
            <br />• Natural disasters
            <br />• Cyberattacks
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>18. GOVERNING LAW</strong>
            <br />
            These Terms are governed by the laws of India.
            <br />
            Disputes shall be subject to courts in Ahmedabad, Gujarat.
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>19. AMENDMENTS</strong>
            <br />
            We may update these Terms periodically.
            Continued use of Haveto Pay constitutes acceptance of updated Terms.
          </Typography.Text>

          <br /><br />

          <Typography.Text className="privacy-text">
            <strong>20. CONTACT</strong>
            <br />
            Haveto.com
            <br />
            Email: contact@haveto.com
            <br />
            Support: contact@haveto.com
          </Typography.Text>

          <br /><br /><br />
        </div>
      </div>
    </>
  );
};

export default TermsOfService;
